import React from "react";
import { Card, CardBody } from "reactstrap";

const AlertasWidget = () => {
  const alertas = [
    {
      nombre: "Oxígeno fuera del rango",
      ubicacion: "Punta Iglesias 2",
      valor: 0.21,
      colorValor: "#f28c38",
      estado: "success",
      tiempo: "1 semana atrás",
    },
    {
      nombre: "Temperatura baja 10°C",
      ubicacion: "Punta Iglesias 2",
      valor: 9.4,
      colorValor: "#e25d37",
      estado: "warning",
      tiempo: "2 semana atrás",
    },
    {
      nombre: "Oxígeno fuera del rango",
      ubicacion: "Punta Iglesias 2",
      valor: 0.21,
      colorValor: "#f28c38",
      estado: "danger",
      tiempo: "2 semana atrás",
    },
  ];

  const dotColor = (estado) => {
    switch (estado) {
      case "danger":
        return "#e25d37";
      case "warning":
        return "#f0ad4e";
      default:
        return "#3ea58a";
    };
  }
    return (
      <Card className="rounded-4 h-100 border-0 shadow-sm">
        <CardBody className="p-3">
          <h5 className="mb-3 fw-bold">Alertas</h5>

          <div className="list-group list-group-flush">
            {alertas.map((a, i) => (
              <div
                key={i}
                className="list-group-item px-0 py-2 d-flex align-items-center border-0"
                style={{ backgroundColor: "transparent" }}
              >
                <span
                  style={{
                    width: 10,
                    height: 10,
                    borderRadius: "50%",
                    backgroundColor: dotColor(a.estado),
                  }}
                  className="me-3 flex-shrink-0"
                />

                <div className="flex-grow-1">
                  <h5 className="fw-semibold mb-0">
                    {a.nombre}
                  </h5>
                  <div className="d-flex align-items-center gap-4">
                    <small className="text-muted d-flex align-items-center">
                      {a.ubicacion}
                    </small>
                    <div className="d-flex align-items-center gap-2">
                      <span
                        style={{
                          width: 8,
                          height: 8,
                          borderRadius: "50%",
                          backgroundColor: a.colorValor,
                        }}
                      ></span>
                      <h5 className="mb-0" style={{ lineHeight: 1 }}>{a.valor}</h5>
                    </div>
                  </div>
                </div>

                <div className="text-end">
                  <h5 className="text-muted">{a.tiempo}</h5>
                </div>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    );
  };

  export default AlertasWidget;
